export enum TrackingIdType {
  APPLICATION_ID = 'applicationId',
  LEASE_ID = 'leaseId',
  LISTING_ALIAS = 'listingAlias',
}

export enum UpsellType {
  CONTACTED_RENTALS = 'contactedRentals',
  LEASES_PAGE = 'leasesPage',
  LEASE_SIGNED_FLOW = 'leaseSignedFlow',
  YOUR_RENTAL_PAGE = 'yourRentalPage',
  YOUR_RENTAL_APPLICATIONS = 'yourRentalApplications',
}

export enum UpsellEntryPointType {
  LEASES_COMPLETED_SIGNING = 'leases_completed_signing',
  LEASES_DASHBOARD = 'leases_dashboard',
  YOUR_RENTAL = 'your_rental',
}

export enum UpsellDismissedStorageKey {
  LEASES = 'isRentersInsuranceUpsellOpenForLease-',
  YOUR_RENTAL = 'hasRentersInsuranceUpsellBeenDismissedForListingAlias-',
  YOUR_RENTAL_APPLICATIONS = 'hasRentersInsuranceUpsellBeenDismissedForApplication-',
}

export type UpsellInfo = {
  shouldDisplayUpsell: boolean;
  isInsuranceRequiredForLease: boolean;
  isInsuranceRequiredForListing: boolean;
  monthlyPriceEstimate: string;
  redirectUrl: string;
  upsellId: string;
  zip: string;
  renderType?: string;
  widgetFields?: {
    params: string;
    state: string;
    street: string;
    city: string;
    email: string;
    firstName: string;
    lastName: string;
    widgetUrl: string;
  };
};
